const META_PIXEL_ID = "1653003389828602";
const SKLIK_SEM_ID = "hno1ryr953x6xmqdpafnk6lv";
const CZK = "CZK";

let lastMetaPageView = "";
let lastSklikPageView = "";
const sentSklikPurchaseIds = new Set();

function sendSklikPurchase(orderId, netValue, taxValue = 0) {
  if (
    !orderId ||
    !Number.isFinite(netValue) ||
    netValue < 0 ||
    typeof window.SEM !== "function" ||
    sentSklikPurchaseIds.has(orderId)
  ) {
    return;
  }

  window.SEM("track", "Purchase", {
    order_id: orderId,
    currency: CZK,
    value: netValue,
    value_tax: taxValue,
  });

  sentSklikPurchaseIds.add(orderId);
  if (sentSklikPurchaseIds.size > 500) {
    sentSklikPurchaseIds.delete(sentSklikPurchaseIds.values().next().value);
  }
}

function getPurchaseFromDataLayerEntry(entry) {
  if (!entry) return null;

  // gtag('event', 'purchase', {...}) queues an Arguments-like object.
  if (typeof entry.length === "number" && entry[0] === "event" && entry[1] === "purchase") {
    return entry[2];
  }

  // Also support the standard GTM ecommerce dataLayer object.
  if (entry.event === "purchase") {
    return entry.ecommerce || entry;
  }

  return null;
}

function installSklikPurchaseBridge() {
  if (typeof window === "undefined") return;

  window.trackHotelBookingPurchase = trackHotelBookingPurchase;

  const dataLayer = (window.dataLayer = window.dataLayer || []);
  if (dataLayer.__hotelSklikPurchaseBridgeInstalled) return;

  const originalPush = dataLayer.push;
  dataLayer.push = function (...entries) {
    const result = originalPush.apply(this, entries);

    entries.forEach((entry) => {
      const purchase = getPurchaseFromDataLayerEntry(entry);
      if (!purchase) return;

      const currency = String(purchase.currency || "").toUpperCase();
      const transactionId = purchase.transaction_id || purchase.order_id;
      const purchaseValue = Number(purchase.value);
      const taxValue = Number(purchase.tax || purchase.value_tax || 0);

      // SEM accepts CZK only and defines `value` as the amount excluding VAT.
      if (
        currency === CZK &&
        transactionId &&
        Number.isFinite(purchaseValue) &&
        Number.isFinite(taxValue)
      ) {
        // GA4's purchase `value` is the item total excluding tax and shipping.
        sendSklikPurchase(String(transactionId), purchaseValue, taxValue);
      }
    });

    return result;
  };
  dataLayer.__hotelSklikPurchaseBridgeInstalled = true;
}

export function trackMarketingPageView(pagePath) {
  if (typeof window === "undefined") return;
  if (!window.Cookiebot || !window.Cookiebot.consent || !window.Cookiebot.consent.marketing) {
    return;
  }

  const pageLocation = `${window.location.origin}${pagePath}`;

  if (typeof window.fbq === "function" && lastMetaPageView !== pageLocation) {
    window.fbq("track", "PageView");
    lastMetaPageView = pageLocation;
  }

  if (typeof window.SEM === "function" && lastSklikPageView !== pageLocation) {
    window.SEM("track", "PageView");
    lastSklikPageView = pageLocation;
  }
}

export function trackPageView(pagePath) {
  if (typeof window === "undefined") return;

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: pagePath,
      page_location: `${window.location.origin}${pagePath}`,
      page_title: document.title,
    });
  }

  trackMarketingPageView(pagePath);
}

/**
 * Explicit fallback for a verified booking-complete callback.
 *
 * `totalValue` is the order total including VAT; `valueExcludingTax` is required
 * for SEM, whose Purchase value must exclude VAT. The Previo iframe is
 * cross-origin, so this must only be called by a trusted confirmation callback
 * supplied by Previo—not on the reservation page or the contact thank-you page.
 */
export function trackHotelBookingPurchase({
  orderId,
  totalValue,
  valueExcludingTax,
  valueTax,
}) {
  const total = Number(totalValue);
  const net = Number(valueExcludingTax);
  const tax = valueTax === undefined ? total - net : Number(valueTax);
  const normalizedOrderId = String(orderId || "").trim();

  if (
    !normalizedOrderId ||
    !Number.isFinite(total) ||
    total <= 0 ||
    !Number.isFinite(net) ||
    net < 0 ||
    !Number.isFinite(tax) ||
    tax < 0
  ) {
    return false;
  }

  const items = [
    {
      item_id: "hotel-accommodation",
      item_name: "Ubytování",
      price: net,
      quantity: 1,
    },
  ];

  if (typeof window.gtag === "function") {
    window.gtag("event", "purchase", {
      transaction_id: normalizedOrderId,
      value: net,
      tax,
      currency: CZK,
      items,
    });
  }

  if (typeof window.fbq === "function") {
    window.fbq(
      "track",
      "Purchase",
      { value: total, currency: CZK },
      { eventID: normalizedOrderId }
    );
  }

  sendSklikPurchase(normalizedOrderId, net, tax);
  return true;
}

installSklikPurchaseBridge();

// Keep these constants discoverable for integrators without exposing secrets.
export const marketingTrackingIds = {
  metaPixelId: META_PIXEL_ID,
  sklikSemId: SKLIK_SEM_ID,
};